import { render, staticRenderFns } from "./DetailBanner.vue?vue&type=template&id=5e233d99&scoped=true"
import script from "./DetailBanner.vue?vue&type=script&lang=js"
export * from "./DetailBanner.vue?vue&type=script&lang=js"
import style0 from "./DetailBanner.vue?vue&type=style&index=0&id=5e233d99&prod&lang=scss&scoped=true"
import style1 from "./DetailBanner.vue?vue&type=style&index=1&id=5e233d99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e233d99",
  null
  
)

export default component.exports